import { render, staticRenderFns } from "./DoctorRegisterRecordList.vue?vue&type=template&id=51b01294&scoped=true&"
import script from "./DoctorRegisterRecordList.vue?vue&type=script&lang=js&"
export * from "./DoctorRegisterRecordList.vue?vue&type=script&lang=js&"
import style0 from "./DoctorRegisterRecordList.vue?vue&type=style&index=0&id=51b01294&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b01294",
  null
  
)

export default component.exports